import { Vue, Component } from 'vue-property-decorator'
import Upload from '../upload/upload.vue'
import { Functions } from '@/library/utils/functions'
import { IPSService } from '@/services/ipsServices'
import validateParams from '@/library/utils/paramFilter'


@Component
export default class PriceTag extends Vue {
    tagConfig: TagConfigClass = {
        state: 0,
        priceConfig: {
            min: null,
            max: null,
        },
        zkConfig: {
            min: null,
            max: null,
        },
        displayList: ['pinfo', 'shareCard'],
        isShowScribingPrice: 0,
        tagPic: '',
    }
    siteId = 0

    mounted() {
        this.siteId = +this.$route.params.siteId
        this.getPriceTag()
    }
    getPriceTag() {
        IPSService.getSiteOtherConfigInfo({
            postParams: {
                siteId: this.siteId,
            },
        }).then((response) => {
            this.tagConfig = response.tagConfig
        });
    }
    onSave() {
       const tagConfig= validateParams(this.tagConfig)
       if(tagConfig.displayList.length===0){
           this.$message.error('展示范围请至少选择一项')
           return ;
       }
        IPSService.saveSiteOtherConfig({
            postParams: {
              siteId: this.siteId,
              tagConfig,
            },
          }).then((response) => {
            if (response.result) {
              this.$message.success('保存成功');
            }
          });
    }
    uploadSuccess(res: HttpAPIRetItem<any>) {
        this.tagConfig.tagPic = res.content;
    }
    render() {
        return (
            <div class="formWrapper">
                <el-form props={{ model: this.tagConfig }} label-position="left" label-width="120px" class="r-px-30 r-pt-2 overflow-auto" ref="form" style="height:calc(100% - 54px)">
                    <div class="formItemWrapper">
                        <div class="blockTitle">价格标签</div>
                        <p class="tip blockTip line-height-24 r-mb-10">注：在商品列表、商品详情及分享海报的商品价格显示处，如商品符合所配置展示价格标签的条件，将显示价格标签。当价格展示为区间时，价格标签不再展示。</p>
                        <el-checkbox v-model={this.tagConfig.state} true-label={1} false-label={0}>启用价格标签</el-checkbox>
                        {!!this.tagConfig.state && <div>
                            <el-form-item class="r-mt-14" label="价格范围">
                                <el-input-number controls={false} v-model={this.tagConfig.priceConfig.min} class="wid-60 r-mr-8" />元&nbsp;&nbsp;&nbsp;~<el-input-number controls={false} v-model={this.tagConfig.priceConfig.max} class="wid-60 r-ml-20 r-mr-8" />元
                            </el-form-item>
                            <el-form-item label="折扣范围">
                                <el-input-number controls={false} v-model={this.tagConfig.zkConfig.min} class="wid-60 r-mr-8" />%&nbsp;&nbsp;&nbsp;~<el-input-number controls={false} v-model={this.tagConfig.zkConfig.max} class="wid-60 r-ml-20 r-mr-8" />%
                            </el-form-item>
                            <el-form-item label="展示范围">
                                <el-checkbox-group v-model={this.tagConfig.displayList}>
                                    <el-checkbox label={'plist'}>商品列表</el-checkbox>
                                    <el-checkbox label={'pinfo'}>商品详情</el-checkbox>
                                    <el-checkbox label={'shareCard'}>分享卡片</el-checkbox>
                                </el-checkbox-group>
                                <el-checkbox style="width:300px;border-top:1px dashed #CBCBCB" v-model={this.tagConfig.isShowScribingPrice} true-label={1} false-label={0}>展示价格标签同时，展示划线价</el-checkbox>
                            </el-form-item>
                            <el-form-item label="标签图片">
                                <div>
                                    <Upload onImgUploadSuccess={val => this.uploadSuccess(val)} img={this.tagConfig.tagPic} class="wid-100" />
                                    <span class="tip"><span class="text-red r-mr-8">*</span>建议上传100px*30px，PNG格式的图片</span></div>
                            </el-form-item>
                        </div>}
                    </div>
                </el-form>
                <div class="bottomWrapper border-top-white">
                    <el-button type="primary" onClick={this.onSave.bind(this)}>
                        保存
                    </el-button>
                </div>
            </div>

        )

    }
}